module.exports = __webpack_public_path__ + "images/file_icons_v2/other-b5ade124bd8ebb58ca04185c8dacd8ed.svg";